import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverViewHeight from 'components/cases/common/OverviewHeight/'
import Interview from './Interview'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import {
  firstViewItemWhite,
  overviewItem,
  overviewTitle,
  issueSolutionItems,
  caseCTAItem,
  caseDownloadCTAItem,
} from './remitItem'
import styles from './remit.module.scss'
import CaseCTA from 'components/cases/common/CaseCTA'
import CaseDownloadCTA from 'components/cases/common/CaseDownloadCTA'
import FooterCTA from 'components/common/FooterCTA'
import MobileAppDevelopment from 'components/services/common/MobileAppDevelopment'

const Remit = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverViewHeight
        overviewItem={overviewItem}
        issueSolutionItems={issueSolutionItems}
        overviewTitle={overviewTitle}
      />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <CaseDownloadCTA {...caseDownloadCTAItem} />
      <FooterCTA />
      <div className={styles.mobileAppWrapper}>
        <MobileAppDevelopment />
      </div>
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
    </>
  )
}

export default Remit
